import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

export default function Preloader({ onDone }) {
  const [count, setCount] = useState(0);
  const doneRef = useRef(false);

  useEffect(() => {
    let value = 0;
    const timer = setInterval(() => {
      value += Math.floor(Math.random() * 14) + 6;
      if (value >= 100) {
        value = 100;
        clearInterval(timer);
        if (!doneRef.current) {
          doneRef.current = true;
          setTimeout(onDone, 500);
        }
      }
      setCount(value);
    }, 120);
    return () => clearInterval(timer);
  }, [onDone]);

  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-obsidian"
      exit={{ y: "-100%", transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1] } }}
    >
      <div className="overflow-hidden px-4">
        <motion.h1
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1, ease: [0.33, 1, 0.68, 1] }}
          className="font-display text-5xl sm:text-7xl font-extrabold tracking-tight text-zinc-100"
        >
          REYA <span className="text-gold">DESING</span>
        </motion.h1>
      </div>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.1, ease: [0.33, 1, 0.68, 1], delay: 0.15 }}
        className="absolute left-1/2 top-1/2 mt-12 h-px w-40 origin-left -translate-x-1/2 bg-gold/60 sm:mt-16"
      />
      <div data-testid="preloader-counter" className="absolute bottom-10 right-10 font-mono text-xl text-gold">
        {count}%
      </div>
      <div className="absolute bottom-10 left-10 font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">
        Marka Mimarlığı
      </div>
    </motion.div>
  );
}
